module.exports = __webpack_public_path__ + "static/media/spain.143123be.svg";